export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    class: isString,
    fullscreen: isBoolean,
    loaderText: isString,
    showLoader: isBoolean,
    styles: isString
  };

  return methods[key] && methods[key](value);
};
